import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vfs-prod-img-temp-imp-steps',
  templateUrl: './prod-img-temp-imp-steps.component.html',
  styleUrls: ['./prod-img-temp-imp-steps.component.scss']
})
export class ProdImgTempImpStepsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
